import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import { User } from 'new/entities/User';

type Members = Pick<
  User,
  'id' | 'access_role' | 'email' | 'full_name' | 'org_membership_status' | 'user_status'
>[];

export function useTeam(teamId: number) {
  const { teams, orgs } = useSelector((state: any) => state?.entities);

  const {
    orgs: { orgMembers },
  } = useSelector((state: any) => state);

  const org = useCurrentOrg();
  const team = teams[teamId];
  const users: Members = orgMembers[org.id]?.membersById || {};

  return useMemo(() => {
    if (!team) {
      return null;
    }
    const org = orgs[team?.org];
    const teamMembers = team.members.map((member) => ({
      ...(users[member?.id] || member),
      org,
    }));
    return {
      ...team,
      org,
      members: teamMembers,
    };
  }, [teams, orgs, users, team]);
}
